import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import NavItemLink from '~/components/Layout/Header/Desktop/NavItemLink';
import type { NavItemType } from '~/types/NavItemType';
import NavItemDropdown from '~/components/Layout/Header/Desktop/NavItemDropdown';

export default component$(
  ({ item, activeItem, level = 0 }: NavItemType): JSX.Element => {
    if (item.children && item.children.length) {
      return (
        <NavItemDropdown item={item} activeItem={activeItem} level={level} />
      );
    }

    return <NavItemLink item={item} level={level} />;
  }
);
